import React from 'react'

// Simple instructional text component for react-select
export const ChannelIdInputOption = () => {
  return (
    <div className="p-2 border-t border-gray-200">
      <p className="text-xs text-gray-500 italic text-left">
        If you do not find your channel,<br/>you can type its ID instead and enter
      </p>
    </div>
  )
}

export default function ChannelIdInput() {
  return <ChannelIdInputOption />
} 